import styled from 'styled-components';

export const VideoContainer = styled.div`
  width: 100%;
  video {
    object-fit: cover;
    width: 100%;
    height: auto;
  }
`;

export const CloseModal = styled.div`
  position: absolute;
  z-index: 99;
  right: 20px;
`;

export const ModalSurveyConfirmationContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  
  > div {
    width: 70%;
    text-align: center;
    margin-bottom: 20px;
    color: white;
  }
`;
